import { createAction } from '@reduxjs/toolkit';
import { MyProfileInfo } from 'config/types/profile';
import { BalanceResponse } from 'services/types';

export const updateBalances = createAction<{ data: BalanceResponse[] }>('profile/updateBalances');
export const updateMyProfile = createAction<{ data: MyProfileInfo }>('profile/updateMyProfile');
